import { useI18n } from "@/i18n";
import { PageHeader } from "@/components/common/PageHeader";
import { Rocket } from "lucide-react";

export default function PlannedModule({ moduleKey }) {
  const { t } = useI18n();
  const navKey = { stock: "products", purchasing: "purchasing", invoices: "invoices", reports: "reports", documents: "documents" }[moduleKey] || moduleKey;
  return (
    <div>
      <PageHeader title={t(`nav.${navKey}`)} />
      <div
        className="flex flex-col items-center justify-center rounded-lg border border-dashed border-slate-300 bg-white/50 px-6 py-20 text-center dark:border-slate-700 dark:bg-slate-900/40"
        data-testid={`planned-${moduleKey}`}
      >
        <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-amber-800 dark:bg-amber-950 dark:text-amber-300">
          <Rocket className="h-3.5 w-3.5" />
          {t("planned.badge")}
        </span>
        <h3 className="font-heading text-xl font-bold text-slate-800 dark:text-slate-100">
          {t("planned.title", { module: t(`nav.${navKey}`) })}
        </h3>
        <p className="mt-2 max-w-md text-sm text-slate-500 dark:text-slate-400">{t(`planned.${moduleKey}`)}</p>
        <p className="mt-1 max-w-md text-sm text-slate-500 dark:text-slate-400">{t("planned.desc")}</p>
      </div>
    </div>
  );
}
